'use strict';

angular.module('theme').service('ProductService', function ($q, $http) {

	var listCache;
	var specialProductListCache;

	this.list = function () {
		if (listCache) {
			return listCache;
		}

		listCache = $http({
			url: '/wp-json/mk/products',
			method: 'GET',
			cache: true
		}).then(function (response) {
			listCache = undefined;
			return response.data;
		});

		return listCache;
	};

	this.specialProductsList = function() {
		if (specialProductListCache) {
			return specialProductListCache;
		}

		specialProductListCache = $http({
			url: '/wp-json/mk/special-products',
			method: 'GET'
		}).then(function (response) {
			specialProductListCache = undefined;
			return response.data;
		});

		return specialProductListCache;
	};

	/**
	 * Used when we display products on page, since we have hidden products we need to filter them out
	 */
	this.visibleList = function () {
		return this.list().then(function (products) {
			return _.filter(products, {hidden: false});
		});
	};

	this.comparableProducts = function() {
		return this.list().then(function (products) {
			var comparableProducts = _.filter(products, {comparison_show: true});

			return _.sortBy(comparableProducts, function(product) { return product['comparison_sort']; });
		});
	};

	this.get = function (productId) {
		if (!productId) {
			return $q.reject('productId cannot be null');
		}

		return this.list().then(function (products) {
			return _.find(products, {product_id: productId});
		});
	};

	this.getSpecialProduct = function(articleId) {
		if (!articleId) {
			return $q.reject('articleId cannot be null');
		}

		return this.specialProductsList().then(function(products) {
			return _.find(products, {article_id: articleId});
		});
	};

});
